import { Notification, NotificationStatus } from "@shared/types";
import { useMemo } from "react";

const useNotificationsList = (notifications?: Notification[][]) => {
  const sortedNotificationsArray = useMemo(
    () => notifications?.slice().sort((a, b) => b[0].time - a[0].time),
    [notifications]
  );

  const numNotifications =
    sortedNotificationsArray && sortedNotificationsArray.length;

  const numUnreadNotifications =
    sortedNotificationsArray?.filter((notification) =>
      notification.some(
        (subItem) => subItem.status === NotificationStatus.UNREAD
      )
    ).length || 0;

  const showNotificationsCounter = numUnreadNotifications > 0;
  const notificationCounterText =
    numUnreadNotifications > 99 ? "99+" : numUnreadNotifications.toString();
  const oneDigitCounter = notificationCounterText.length === 1;

  return {
    sortedNotificationsArray,
    numNotifications,
    numUnreadNotifications,
    notificationCounterText,
    oneDigitCounter,
    showNotificationsCounter,
  };
};

export default useNotificationsList;
